/*
 * Created by alex@hackerbay.com on 5.2.2019
 * Copyright Singularity Technologies GmbH (c) 2019. All rights reserved
 */

/**
 * R.Gebert [10:25 AM] 13.02.2019 (Vodafone-Hackerbay Slack)
 * Termin nötig ist die 1. Bei 0 benötigt der Kunde keinen Termin.
 * @param ds360APIResult
 * @returns {*|boolean}
 */
function technicianAppointmentRequired(ds360APIResult){
    return ds360APIResult.flg_default_proceeding === 1;
}

export default technicianAppointmentRequired;